export default {
      id: "icon-linkedin-usage",
      viewBox: "0 0 31.264 31.263",
      url: __webpack_public_path__ + "img/icons.svg#icon-linkedin",
      toString: function () {
        return this.url;
      }
    }